module.exports = __webpack_public_path__ + "static/media/placeholder.439750f9.svg";